import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function Contact_FAQ() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-3'>
    <div className={classes.root}>
    <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What services does InternsElite offer?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          InternsElite offers a variety of services, including multiple training and internship programs in both tech and non-tech fields. Our platform facilitates personalized internship placements tailored to individual career interests and skill sets. We provide opportunities for students to gain hands-on experience, professional development, and networking with industry leaders across diverse sectors.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>Can students visit InternsElite's office for inquiries or assistance?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          No, students cannot visit InternsElite's office for inquiries or assistance. Our support team handles all queries remotely to ensure efficient and timely responses. Please reach out to us via our support number or contact us through email for any assistance you need.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>Does InternsElite conduct walk-in drives for job opportunities?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Yes, InternsElite occasionally organizes walk-in drives for job opportunities. Stay informed about upcoming drives by regularly visiting our careers page or contacting our recruitment team for updates.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>Does InternsElite offer in-person consultations or meetings?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          To maintain efficiency and serve students globally, InternsElite does not offer in-person consultations or meetings. However, our support team is available to assist you remotely.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>How can students enroll in our programs?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Students can enroll in our programs by visiting our website and filling out the registration form at <a href='https://internselite.net/Student-Register'>https://internselite.net/Student-Register</a>. Additionally, they can call our support number or drop a mail at support@internelite.com for counseling and further assistance.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What payment methods does InternsElite accept?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          InternsElite accepts payments through Razorpay, Paytm, and PhonePe. For any specific inquiries or assistance with payments, please contact our support team.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>Does InternsElite offer refunds on fees and charges?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            No, InternsElite does not offer refunds on any fees and charges for products or services, including partially used or unused periods, subscriptions, one-time payments, or slot booking fees. Refunds are not guaranteed for lack of usage or dissatisfaction. InternsElite is not responsible for third-party marketplace refund policies.
            <br></br>Reason for No Refunds: After registration, students receive a traineeship/internship letter, committing resources and opportunities, which makes refunds impractical.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
